export default __webpack_public_path__ + "static/media/backgroundLogoPomelo.0e9f0e45.svg";